export interface Permission {
    id: number;
    groupName: string;
    title: string;
    authority: string;
}

export const routePermissions = {
    superAdmin: {
        all: ["ROLE_SUPER_ADMIN"]
    },
    dashboard: {
        list: ["DASHBOARD"]
    },
    blogs: {
        list: ["BLOG_READ_ALL"],
        create: ["BLOG_CREATE"],
        edit: ["BLOG_UPDATE"],
        delete: ["BLOG_DELETE"],
        view: ["BLOG_READ"]
    },
    users: {
        list: ["USER_READ_ALL"],
        create: ["USER_CREATE"],
        edit: ["USER_UPDATE"],
        delete: ["USER_DELETE"],
        view: ["USER_READ"]
    },
    products: {
        list: ["PRODUCT_READ_ALL"],
        create: ["PRODUCT_CREATE"],
        edit: ["PRODUCT_UPDATE"],
        delete: ["PRODUCT_DELETE"],
        view: ["PRODUCT_READ"]
    },
    categories: {
        list: ["CATEGORY_READ_ALL"],
        create: ["CATEGORY_CREATE"],
        edit: ["CATEGORY_UPDATE"],
        delete: ["CATEGORY_DELETE"],
        view: ["CATEGORY_READ"]
    },
    features: {
        list: ["FEATURE_READ_ALL"],
        create: ["FEATURE_CREATE"],
        edit: ["FEATURE_UPDATE"],
        delete: ["FEATURE_DELETE"],
        view: ["FEATURE_READ"]
    },
    offers: {
        list: ["OFFER_READ_ALL"],
        create: ["OFFER_CREATE"],
        edit: ["OFFER_UPDATE"],
        delete: ["OFFER_DELETE"],
        view: ["OFFER_READ"]
    },
    coupons: {
        list: ["COUPON_READ_ALL"],
        create: ["COUPON_CREATE"],
        edit: ["COUPON_UPDATE"],
        delete: ["COUPON_DELETE"],
        view: ["COUPON_READ"]
    },
    contacts: {
        list: ["CONTACT_READ_ALL"],
        delete: ["CONTACT_DELETE"],
        view: ["CONTACT_READ"]
    },
    carts: {
        list: ["CART_READ_ALL"],
        update: ["CART_UPDATE"],
        view: ["CART_READ"]
    },
    paymentLinks: {
        // Own PAYMENT_LINK_* group. list admits either: the backend itself decides
        // own-only vs. everyone's per holder.
        list: ["PAYMENT_LINK_READ", "PAYMENT_LINK_READ_ALL"],
        create: ["PAYMENT_LINK_CREATE"],
        update: ["PAYMENT_LINK_UPDATE"]
    },
    customers: {
        list: ["CUSTOMER_READ_ALL"],
        update: ["CUSTOMER_UPDATE"],
        view: ["CUSTOMER_READ"]
    },
    paymentMethods: {
        list: ["PAYMENT_METHOD_READ_ALL"],
        view: ["PAYMENT_METHOD_READ"]
    },
    companyCustomers: {
        list: ["COMPANY_CUSTOMER_READ_ALL"],
        create: ["COMPANY_CUSTOMER_CREATE"],
        edit: ["COMPANY_CUSTOMER_UPDATE"],
        delete: ["COMPANY_CUSTOMER_DELETE"],
        view: ["COMPANY_CUSTOMER_READ"]
    },
    specialRequests: {
        list: ["SPECIAL_REQUEST_READ_ALL"],
        update: ["SPECIAL_REQUEST_UPDATE"],
        view: ["SPECIAL_REQUEST_READ"]
    },
    sliders: {
        list: ["SLIDER_READ_ALL"],
        create: ["SLIDER_CREATE"],
        edit: ["SLIDER_UPDATE"],
        delete: ["SLIDER_DELETE"],
        view: ["SLIDER_READ"]
    },
    banners: {
        create: ["BANNER_CREATE"],
        edit: ["BANNER_UPDATE"],
        delete: ["BANNER_DELETE"],
    },
    cartTracking: {
        list: ["CART_TRACKING_READ_ALL"],
        update: ["CART_TRACKING_UPDATE"]
    },
    specialRequestTracking: {
        list: ["SPECIAL_REQUEST_TRACKING_READ_ALL"],
        update: ["SPECIAL_REQUEST_TRACKING_UPDATE"]
    },
    newsLetter: {
        list: ["NEWSLETTER_READ_ALL"],
        view: ["NEWSLETTER_READ"]
    },
    companyInfo: {
        update: ["COMPANY_INFO_UPDATE"],
        view: ["COMPANY_INFO_READ"]
    }
}; 